/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_HelicopterInputs */

const en_val_helicopter = /** @type {(inputs: Val_HelicopterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Helicopter`)
};

const es_val_helicopter = /** @type {(inputs: Val_HelicopterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Helicóptero`)
};

const fr_val_helicopter = /** @type {(inputs: Val_HelicopterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hélicoptère`)
};

const de_val_helicopter = /** @type {(inputs: Val_HelicopterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubschrauber`)
};

const ja_val_helicopter = /** @type {(inputs: Val_HelicopterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ヘリコプター`)
};

const zh_val_helicopter = /** @type {(inputs: Val_HelicopterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`直升机`)
};

const ar_val_helicopter = /** @type {(inputs: Val_HelicopterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مروحية (هليكوبتر)`)
};

const id_val_helicopter = /** @type {(inputs: Val_HelicopterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Helikopter`)
};

const it_val_helicopter = /** @type {(inputs: Val_HelicopterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elicottero`)
};

const ru_val_helicopter = /** @type {(inputs: Val_HelicopterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вертолет`)
};

const pt_val_helicopter = /** @type {(inputs: Val_HelicopterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Helicóptero`)
};

const ko_val_helicopter = /** @type {(inputs: Val_HelicopterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`헬리콥터`)
};

/**
* | output |
* | --- |
* | "Helicopter" |
*
* @param {Val_HelicopterInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_helicopter = /** @type {((inputs?: Val_HelicopterInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_HelicopterInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_helicopter(inputs)
	if (locale === "es") return es_val_helicopter(inputs)
	if (locale === "fr") return fr_val_helicopter(inputs)
	if (locale === "de") return de_val_helicopter(inputs)
	if (locale === "ja") return ja_val_helicopter(inputs)
	if (locale === "zh") return zh_val_helicopter(inputs)
	if (locale === "ar") return ar_val_helicopter(inputs)
	if (locale === "id") return id_val_helicopter(inputs)
	if (locale === "it") return it_val_helicopter(inputs)
	if (locale === "ru") return ru_val_helicopter(inputs)
	if (locale === "pt") return pt_val_helicopter(inputs)
	return ko_val_helicopter(inputs)
});